export const locale = {
    lang: 'en',
    data: {
      'WIZARD': {
        'VERSION_PROD':{
          '20':'2.0',
          '40':'3.0',
          '41':'3.0',
          '42':'3.0',
        },
        'TESTTITULO': 'WIZARD TITLE :V',
        'CARGANDO': 'Loading acquired products',
        'CARGANDO_PULSOS': 'Loading pulses in process.',
        'SINPRODS': 'You have not acquired this product',
        'EVALUADOR':{
          'TITUTLO':'Evaluator'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': 'Welcome to CULTURAL GO!',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'Amco':{
              'TITULO': 'WELCOME TO AMCO',
              'CURRENT': 'This is the current amco process',
              'FINISHED': 'This is a completed amco process.',
              'RESULTS': {
                'CURRENT': 'Amco process not finished',
                'FINISHED': 'This is the current result process',
                'FINISHED5': 'Result process'
              }
            },
            'Trabajo_digno':{
              'TITULO': 'WELCOME TO DECENT WORK',
              'CURRENT': 'This is the current decent work process',
              'FINISHED': 'This is a completed decent work process',
              'RESULTS': {
                'CURRENT': 'Decent work process not finished.',
                'FINISHED': 'This is the current result process',
                'FINISHED5': 'Result process'
              }
            },
            'Primer_empleo':{
              'TITULO': 'WELCOME TO FIRST JOB',
              'CURRENT': 'This is the current first employment process',
              'FINISHED': 'This is a completed first job process.',
              'RESULTS': {
                'CURRENT': 'First employment process not completed',
                'FINISHED': 'This is the current result process',
                'FINISHED5': 'Result process',
              }
            },
            'CERTIFICAR_ESPAIN':{
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'CERTIFICAR_C1':{
              'TITULO': 'Welcome to CULTURAL GO!',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',

              //ESPAÑA
              'TITULO_ESPAIN': 'Welcome to CULTURAL GO!',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'CERTIFICAR_C2':{
              'TITULO': 'Welcome to CULTURAL GO!',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process'
              }
            },
            'CERTIFICAR_C3':{
              'TITULO': 'Welcome to CULTURAL GO!',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': 'WELCOME TO CERTIFY SILVER',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'CERTIFICAR_C6':{
              'TITULO': 'WELCOME TO GPTW + GCTI',
              'CURRENT': 'This is your current survey process',
              'FINISHED': 'This is a finished survey process',
              'RESULTS': {
                'CURRENT': 'Survey process not finished',
                // 'FINISHED': 'Finished survey process'
                'FINISHED': 'This is your current survey process',
                'FINISHED5': 'Process results'
              }
            },
            'MEDIR':{
              'TITULO': 'WELCOME TO MEASUREMENT',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                // 'FINISHED': 'Finished measurement process'
                'FINISHED': 'This is your current measurement process',
                'FINISHED5': 'Process results'

              }
            },
            'MEDIR_M1':{
              'TITULO': 'WELCOME TO MEASUREMENT ENHANCED',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M2':{
              'TITULO': 'WELCOME TO MEASUREMENT + MST',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M3':{
              'TITULO': 'WELCOME TO MEASUREMENT BY AREAS',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M4':{
              'TITULO': 'WELCOME TO MEASUREMENT BY LEADERS',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M5':{
              'TITULO': 'WELCOME TO MEASUREMENT BY DIMENSIONS',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M6':{
              'TITULO': 'WELCOME TO MEASUREMENT TO CERTIFY',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M7':{
              'TITULO': 'WELCOME TO MEASUREMENT 3.0',
              'CURRENT': 'This is your current measurement process',
              'FINISHED': 'This is a finished measurement process',
              'RESULTS': {
                'CURRENT': 'Measurement process not finished',
                'FINISHED': 'Finished measurement process'
              }
            },
            'MEDIR_M8':{
              'TITULO': 'WELCOME TO ICI',
              'CURRENT': 'This is your current product process',
              'FINISHED': 'This is a finished product process',
              'RESULTS': {
                'CURRENT': 'Product process not finished',
                'FINISHED': 'Finished product process'
              }
            },
            'MEDIR_M9':{
              'TITULO': 'WELCOME TO INNMOTION SURVEY',
              'CURRENT': 'This is your current product process',
              'FINISHED': 'This is a finished product process',
              'RESULTS': {
                'CURRENT': 'Product process not finished',
                'FINISHED': 'Finished product process'
              }
            },
            'PULSE':{
              'TITULO': 'WELCOME TO PULSE CHECK',
              'ADMINTITULO': 'ADMINISTRATOR  PULSE CHECK´S',
              'PRODU': 'Pulse Check',
              'CURRENT': 'This is your current Pulse Check process',
              'PULSOS': 'This is a Pulse Check process',
              'FINISHED': 'This is a finished Pulse Check process',
              'CARGANDO_PULSE':'Loading pulsechecks in process',
              'ENTRAR': 'Start',
              'RESULTS': {
                'CURRENT': 'Pulse Check process not finished',
                // 'FINISHED': 'Finished Pulse Check process'
                'FINISHED': 'This is your current Pulse Check process'
              }
            },
            'PULSE_T1':{
              'TITULO': 'WELCOME TO PULSE CHECK 3.0',
              'ADMINTITULO': 'ADMINISTRATOR  PULSE CHECK´S',
              'PRODU': 'Pulse Check',
              'CURRENT': 'This is your current Pulse Check process',
              'PULSOS': 'This is a Pulse Check process',
              'FINISHED': 'This is a finished Pulse Check process',
              'ENTRAR': 'Start',
              'RESULTS': {
                'CURRENT': 'Pulse Check process not finished',
                // 'FINISHED': 'Finished Pulse Check process'
                'FINISHED': 'This is your current Pulse Check process'
              }
            },
            'FOCUS':{
              'SECTION': 'Groups administrator',
              'TITLE': 'Groups administrator',
              'SUBTI': 'Selection or creation of groups',
              'LAND': {
                'NAME': 'Survey name',
                'INICIO': 'Start date',
                'FIN': 'Target date',
                'AVANCE': 'Advance',
                'ESTADO': 'Status',
                'COMP': 'Behavior',
                'CREARENC': 'Create survey',
                'DELETE': 'Delete',
                'EDIT': 'Edit',
              },
              'TITULO': 'WELCOME TO FOCUS AREA',
              'CURRENT': 'This is your current focus area process',
              'FINISHED': 'This is a finished focus area process',
              'RESULTS': {
                'CURRENT': 'Focus Area process not finished',
                'FINISHED': 'Finished Focus Area process'
              }
            },
            'FOCUS_1':{
              'SECTION': 'Groups administrator',
              'TITLE': 'Groups administrator',
              'SUBTI': 'Selection or creation of groups',
              'ADMINTITULO': 'ADMINISTRATOR FOCUS AREAS',
              'PRODU': 'Focus Area',
              'CARGANDO_FOCUS':'Loading focus area in process',
              'TAB_PROC_FOC':'Focus Area Processes',
              'TAB_SUBIDA_COLB_FOC':'Collaborator upload',
              'INST_MOD_FILTER_1':'Upload your list of contributors',
              'INST_MOD_FILTER_2':'Enter the survey of your choice',
              'LAND': {
                'NAME': 'Survey name',
                'INICIO': 'Start date',
                'FIN': 'Target date',
                'AVANCE': 'Advance',
                'ESTADO': 'Status',
                'COMP': 'Behavior',
                'CREARENC': 'Create survey',
                'DELETE': 'Delete',
                'EDIT': 'Edit',
              },
              'TITULO': 'WELCOME TO FOCUS AREA',
              'CURRENT': 'This is your current focus area process',
              'FINISHED': 'This is a finished focus area process',
              'RESULTS': {
                'CURRENT': 'Focus Area process not finished',
                'FINISHED': 'Finished Focus Area process'
              }
            }
          },
          'DONE': 'Application year: ',
          'LEGA': 'Legacy results',
          'FOCUS': 'SURVEY´S TO FOCUS AREA',
          'ENTRAR': 'Start',
          'IR':'Go',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'Culture Brief ve Culture Audit 5.0',
            'TITULO-1':'Culture Brief ve Culture Audit 5.0',
            'TITULO1':'Culture Brief ve Culture Audit 5.0',
            'TITULO2':'Culture Brief 5.0',
            'TITULO3':'Culture Audit 5.0',
            'TITULO4':'Special List',

          },
          'INST-CHINA':{
            'TITULO':'Culture Audit',
            'TITULO1':'Culture Audit',
            'TITULO2':'Culture Audit 5.0',
            'TITULO3':'Culture Audit SP',
            'TITULO4':'Culture Audit 5.0',
            'TITULO5':'Culture Audit 4All',
          },
          'INST-ESP':{
            'TITULO':'Culture Audit',
            'TITULO1':'Culture Audit',
            'TITULO2':'Culture Audit 5.0',
            'TITULO3':'Action Plan',
          }
        },
        'STEPSTAT': {
          'LOCK': 'Step locked',
          'PEND': 'Step open',
          'COMP': 'Step completed'
        },
        'NOPRODUCTS': {
          'TITULO': 'Your company has no acquired products',
          'SUBTI': 'Information about the offer'
        },
        'GUIA35': {
          'TITULO': 'Guide NOM-035-STPS-2018',
          'SUBTITULO':'Description',
          'DESCRIPCION': 'Information about NOM-035-STPS-2018',
          'ENTRAR': 'START'
         },
        'ENCUESTA35': {
          'TITULO': 'Pollster NOM-035-STPS-2018',
          'TITULO2': 'Pollster NOM-035-STPS-2018',
          'SUBTITULO':'Description',
          'DESCRIPCION': 'The following section belongs to a surveyor of NOM-035-STPS-2018, in which the different psychosocial risk factors in the organizational environment of workers will be identified',
          'ENTRAR': 'START'
        },
        'CERTIFICAR_ESPAIN': {
          'TITULO': 'Diagnose',
        },
        'Amco': {
          'TITULO': 'Amco',
        },
        'Trabajo_digno': {
          'TITULO': 'Decent work',
        },
        'Primer_empleo': {
          'TITULO': 'First job',
        },
        'NOM35V3': {
            'TITULO': 'Norm 035 3.0'
        },
        'CERTIFICAR_C4': {
            'TITULO': 'Certify silver'
        },
        'CERTIFICAR_C6': {
            'TITULO': 'GPTW + GCTI'
        },
        'CERTIFICAR': {
          'TITULO': 'Certify',
          'TITULO_ESPAIN': 'Diagnose',
          'TITULO_GPTWGCTI': 'GPTW + GCTI',
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'NPS Edition'
            },
            'STP1-1': {
              'WIZBT': 'Statements',
              'TITULO': 'Statements',
              'SUBTI': 'Statements edit'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': 'Templates',
              'TITULO': 'Templates',
              'SUBTI': 'Statements edit'
            },
            'STP2': {
              'WIZBT': 'For All Practices',
              'TITULO': 'For All Practices',
              'SUBTI': 'Insert For All practices of your company for the survey'
            },
            'STP_CONTROL': {
              'WIZBT': 'Control question',
              'TITULO': 'Control question',
              'SUBTI': 'Editing the control question'
            },
            'STP3': {
              'WIZBT': 'Demographics',
              'TITULO': 'Demographics',
              'SUBTI': 'Insert the demographics information to be shown in the survey. NOTE: Demographics in yellow are optional'
            },
            'STP3-1': {
              'WIZBT': 'Open questions',
              'TITULO': 'Open questions',
              'SUBTI': 'Insert the open questions'
            },
            'STP4': {
              'WIZBT': 'Additionals',
              'TITULO': 'Additionals',
              'SUBTI': 'Insert additional questions for the survey'
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT': 'Personalized',
              'TITULO': 'Personalized',
              'SUBTI': 'Insert Personalized questions for the survey'
            },
            'STP4-1': {
              'WIZBT': 'Generate survey',
              'TITULO': 'Generate survey',
              'SUBTI': 'Generate the survey',
              'WIZBT2': 'Survey',
              'TITULO2': 'Survey',
            },
            'STP5': {
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'Upload your company participant employees database'
            },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule the survey\'s launching and reminders dates'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your pilot participants'
            },
            // 'STP8': {
            //   'WIZBT': 'Survey close',
            //   'TITULO': 'Survey close',
            //   'SUBTI': 'Progress before the closing of the survey'
            // },
            'STP8': {
              'WIZBT': 'Survey follow-up',
              'TITULO': 'Survey follow-up',
              'SUBTI': 'Progress before the survey closes'
            },
            'STP9': {
              'WIZBT': 'Activate survey',
              'TITULO': 'Activate survey',
              'SUBTI': 'Activate the survey'
            },
            'STP10': {
              'WIZBT': 'Template',
              'TITULO': 'Activate survey',
              'SUBTI': 'Make modifications to the template'
            },
            'STP_VOICE': {
              'WIZBT': 'Voice settings',
              'TITULO': 'Set the voice settings for the survey with audio',
              'SUBTI': 'Set the voice settings for the survey with audio'
            }
          }
        },
        'CERTIFICARAMCO': {
          'TITULO': 'AMCO',
        },
        'CERTIFICARTRABADIG': {
          'TITULO': 'Decent work',
        },
        'CERTIFICARADICPRIEMPL': {
          'TITULO': 'First job',
        },
        'CERTIFICAR_C2': {
          'TITULO': 'Izzi',
        },
        'CERTIFICAR35': {
          'TITULO': 'NOM-035-STPS-2018',
          'LANDING': {
            'TITULO': 'WELCOME TO NOM-035-STPS-2018',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP2': {
              'WIZBT': 'For All Practices',
              'TITULO': 'For All Practices',
              'SUBTI': 'Insert the For All practices of your company for the survey'
            },
            'STP3': {
              'WIZBT': 'Demographics',
              'TITULO': 'Demographics',
              'SUBTI': 'Insert the demographics information to be shown in the survey'
            },
            'STP4': {
              'WIZBT': 'Additionals',
              'TITULO': 'Additionals',
              'SUBTI': 'Insert additional questions for the survey'
            },
            'STP5': {
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'You have not loaded your participants database'
            },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule the survey\'s launching and reminders dates'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },
            'STP8': {
              'WIZBT': 'Survey close',
              'TITULO': 'Survey close',
              'SUBTI': 'Progress before the closing of the survey'
            },'STP9':{
              'WIZBT': 'Communication plan',
              'TITULO': 'Communication plan',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },'STP10':{
              'WIZBT': 'Participants',
              'TITULO': 'Participants',
              'SUBTI': 'Get ready for the NOM-035-STPS-2018 Survey '
            }
          }
        },
        'PULSE': {
          'TITULO': 'Pulse Check',
          'LANDING': {
            'TITULO': 'WELCOME TO PULSE CHECK',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            // 'STP1': {
            //   'WIZBT': 'Languages',
            //   'TITULO': 'Languages',
            //   'SUBTI': 'Languages selection',
            // },
            // 'STP1-1': {
            //   'WIZBT': 'Statements',
            //   'TITULO': 'Statements',
            //   'SUBTI': 'Statements selection'
            // },
            // 'STP2': {
            //   'WIZBT': 'For All practices',
            //   'TITULO': 'For All practices',
            //   'SUBTI': 'Insert the For All practices of your company for the survey'
            // },
            // 'STP3': {
            //   'WIZBT': 'Demographics',
            //   'TITULO': 'Demographics',
            //   'SUBTI': 'Insert the demographics information to be shown in the survey'
            // },
            // 'STP3-1': {
            //   'WIZBT': 'Open questions',
            //   'TITULO': 'Open questions',
            //   'SUBTI': 'Insert the open questions'
            // },
            // 'STP4': {
            //   'WIZBT': 'Additionals',
            //   'TITULO': 'Additionals',
            //   'SUBTI': 'Insert additional questions for the survey'
            // },
            // 'STP5': {
            //   'WIZBT': 'Participants',
            //   'TITULO': 'Participants',
            //   'SUBTI': 'Upload your company collaborators database'
            // },
            'STP6': {
              'WIZBT': 'Schedule survey',
              'TITULO': 'Schedule survey',
              'SUBTI': 'Schedule survey dates Pulse Check'
            },
            'STP7': {
              'WIZBT': 'Mail sender',
              'TITULO': 'Mail sender',
              'SUBTI': 'Send the survey invitation to your collaborators'
            },
            'STP8': {
              'WIZBT': 'Survey progress',
              'TITULO': 'Survey progress',
              'SUBTI': 'Check the progress of the surveys Pulse Check',
            }
          }
        },
        'PULSE_T1': {
          'TITULO': 'Pulse Check 3.0',
          'LANDING': {
            'TITULO': 'WELCOME TO PULSE CHECK 3.0',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
          }
        },
        'CERTIFICAR_C1': {
          'TITULO': 'Alternative Certify',
          'LANDING': {
            'TITULO': 'WELCOME TO ALTERNATIVE CERTIFY',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR': {
          'TITULO': 'Measurement',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M1': {
          'TITULO': 'Measurement enhanced',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT ENHANCED',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M2': {
          'TITULO': 'Measurement + MST',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT + MST',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M3': {
          'TITULO': 'Measurement by areas',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY AREAS',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M4': {
          'TITULO': 'Measurement by leaders',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY LEADERS',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M5': {
          'TITULO': 'Measurement by dimensions',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT BY DIMENSIONS',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M6': {
          'TITULO': 'Measurement to certify',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT TO CERTIFY',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M7': {
          'TITULO': 'Measurement 3.0',
          'LANDING': {
            'TITULO': 'WELCOME TO MEASUREMENT 3.0',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M8': {
          'TITULO': 'ICI',
          'LANDING': {
            'TITULO': 'WELCOME TO ICI',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'MEDIR_M9': {
          'TITULO': 'Innmotion survey',
          'LANDING': {
            'TITULO': 'WELCOME TO INNMOTION SURVEY',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          }
        },
        'FOCUS':{
          'TITULO': 'Focus Area',
          'LANDING': {
            'TITULO': 'WELCOME TO FOCUS AREA',
            'DONE': 'Application year: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Languages selection'
            },
            'STP2': {
              'WIZBT': 'Manage Groups',
              'TITULO': 'Manage Groups',
              'SUBTI': 'Insert the For All practices of your company for the survey'
            },
            'STP3': {
              'WIZBT': 'Administer Surveys',
              'TITULO': 'Administer Surveys',
              'SUBTI': 'Insert the demographics information to be shown in the survey'
            },
            'STP4': {
              'WIZBT': 'Survey Board',
              'TITULO': 'Survey Board',
              'SUBTI': 'Insert additional questions for the survey'
            }
          }
        },
        'LEADER_GO':{
          'TITULO_ADMIN': 'LEADER GO® WELCOME ADMINISTRATOR',
          'TITULO': 'LEADER GO® WELCOME',
          'TITULO_PRODUCT':'Leader Go® administrator',
          'TITULO_PRODUCT2':'Leader Go®',
          'LANDING': {
            'TITULO': 'WELCOME TO LEADER GO',
            'DONE': 'Year of application: ',
            'ENTRAR': 'Start'
          },
          'STEPS': {
            'STP1': {
              'WIZBT': 'Languages',
              'TITULO': 'Languages',
              'SUBTI': 'Language selection'
            },
            'STP2': {
              'WIZBT': 'Leader selection',
              'TITULO': 'Leader selection',
              'SUBTI': 'Select leaders',
            },
            'STP3': {
              'WIZBT': 'Communication messages',
              'TITULO': 'Communication messages',
              'SUBTI': 'Login to edit the mails ',
            },
            'STP4': {
              'WIZBT': 'Confirmation',
              'TITULO': 'Confirmation',
              'SUBTI': 'Enter to confirm sending of emails',
            },
            'STP5': {
              'WIZBT': 'Advance',
              'TITULO': 'Advance',
              'SUBTI': 'Advance',
            }
          }

        },
        'ACTION_GO':{
          'TITULO_ADMIN': 'ACTION GO® WELCOME ADMINISTRATOR',
          'TITULO': 'ACTION GO® WELCOME',
          'TITULO_PRODUCT':'Action GO® administrator',
          'TITULO_PRODUCT2':'Action GO®',
        },
        'LANDING_REQUERIMIENTOSV3':{
            'TITULO':'Technical Requirements',
            'EXTERNAL_PORTAL': 'Copy external RT url',
            'COPYA_MESSAGE':'The url has been copied to the clipboard',

        },
        'GOFLOW':{
          'TITULO': 'GoFlow Results',
        },
      }
    }
};
